import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

}));

export const CountCreations = ({ termArray }) => {
  const classes = useStyles();
  const chartRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(800); // Standardbreite

  useEffect(() => {
    // Ermitteln der Breite des übergeordneten Elements
    const handleResize = () => {
      if (chartRef.current) {
        setContainerWidth(chartRef.current.parentElement.offsetWidth);
      }
    };

    handleResize(); // Initiale Breite ermitteln
    window.addEventListener('resize', handleResize); // Event-Listener für Fenstergröße

    return () => {
      window.removeEventListener('resize', handleResize); // Event-Listener entfernen
    };
  }, []);

  //console.log("termArray in Hist Plot");
  //console.log(termArray);

  let creatorArray = [];
  let formattedData = [];


  if (termArray) {
    creatorArray = termArray.map((item) => {
      return item.creator.email
    });
  }

  //console.log("creatorArray");
  //console.log(creatorArray);

  // Schritt 1: Häufigkeit der Strings zählen
  const frequency = creatorArray.reduce((acc, creator) => {
    acc[creator] = (acc[creator] || 0) + 1;
    return acc;
  }, {});

  // Schritt 2: Eindeutiges Array erstellen
  const uniqueArray = Object.keys(frequency);

  //console.log("Häufigkeit der Strings:", frequency);
  //console.log("Eindeutiges Array:", uniqueArray);

  // Schritt 3: Array im gewünschten Format erstellen
  formattedData = uniqueArray.map(creator => ({
    creator: creator, // Konvertieren Sie das Datum in ein Date-Objekt
    count: frequency[creator],
  }));

  //console.log("formattedData:", formattedData);

  return (
    <div>      
      <div ref={chartRef}>
        {formattedData.map((data, index) => (
          <div key={index} className={classes.item}>
            <span className={classes.creator}>{data.creator}</span>: <span className={classes.count}>{data.count}</span>
          </div>
        ))}
      </div>
      <div>         
        ({termArray.length} Created Terms)
      </div>
    </div>
  )
};